import PublicAPI from "./api";


export const PublicProductAPI = {
    list_products: async (options = {}) => {
        return await PublicAPI.get('/products', { signal: options.signal });
    },
    get_product_by_id: async (id, options = {}) => {
        return await PublicAPI.get(`/products/${id}`, { signal: options.signal });
    },
};